import { render, staticRenderFns } from "./statistics-data.vue?vue&type=template&id=19c1c361"
import script from "./statistics-data.vue?vue&type=script&lang=js"
export * from "./statistics-data.vue?vue&type=script&lang=js"
import style0 from "./statistics-data.vue?vue&type=style&index=0&id=19c1c361&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports